import {
  Activity,
  Brain,
  Footprints,
  Leaf,
  Play,
  Salad,
  Scale,
  Syringe,
  Target,
  TrendingDown,
  Utensils,
  type LucideIcon,
} from "lucide-react";
import type { Goal } from "@bioflow/contracts";

/**
 * Иконки по именам из контента. Контент (content/*.ts) остаётся чистыми
 * данными, а какая именно пиктограмма стоит за «желудком» или «мозгом»,
 * решается здесь — в одном месте.
 */
const ICONS: Record<string, LucideIcon> = {
  hunger: Salad,
  appetite: Utensils,
  plate: Utensils,
  brain: Brain,
  chart: TrendingDown,
  weight: TrendingDown,
  drug: Syringe,
  format: Syringe,
  start: Play,
  food: Leaf,
  active: Footprints,
  scale: Scale,
  target: Target,
};

export function ContentIcon({ name, size = 20 }: { name: string; size?: number }) {
  const Icon = ICONS[name] ?? Activity;
  return <Icon size={size} strokeWidth={1.9} aria-hidden />;
}

/** Небольшая иконка к каждой цели онбординга. */
export const GOAL_ICONS: Record<Goal, LucideIcon> = {
  lose_weight: TrendingDown,
  control_appetite: Utensils,
  reduce_cravings: Brain,
  maintain_weight: Scale,
  explore: Target,
};

/**
 * Моковая «3D-молекула» для экрана «Как работает»: атомы и связи на токенах
 * темы. SVG инлайновый — весит меньше, чем запрос за картинкой, и красится
 * под тёмную тему сам.
 */
export function Molecule({ size = 160 }: { size?: number }) {
  const atoms = [
    { cx: 80, cy: 80, r: 22, tone: "a" },
    { cx: 30, cy: 52, r: 13, tone: "b" },
    { cx: 130, cy: 48, r: 15, tone: "b" },
    { cx: 46, cy: 128, r: 12, tone: "c" },
    { cx: 126, cy: 124, r: 11, tone: "c" },
    { cx: 80, cy: 22, r: 9, tone: "c" },
  ];
  return (
    <svg className="molecule" viewBox="0 0 160 160" width={size} height={size} aria-hidden focusable="false">
      <g className="molecule__bonds">
        {atoms.slice(1).map((atom) => (
          <line key={`${atom.cx}-${atom.cy}`} x1={80} y1={80} x2={atom.cx} y2={atom.cy} />
        ))}
      </g>
      {atoms.map((atom) => (
        <circle key={`${atom.cx}-${atom.cy}`} cx={atom.cx} cy={atom.cy} r={atom.r} className={`molecule__atom molecule__atom--${atom.tone}`} />
      ))}
    </svg>
  );
}
